import PrimeVue from 'primevue/config'

import { Form } from '@primevue/forms'
import FormField from '../vue/FormField.vue'

import Button from 'primevue/button'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import CheckboxGroup from 'primevue/checkboxgroup'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice'
import DataTable from 'primevue/datatable'
import DatePicker from 'primevue/datepicker'
import Dialog from 'primevue/dialog'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import MultiSelect from 'primevue/multiselect'
import ProgressSpinner from 'primevue/progressspinner'
import RadioButton from 'primevue/radiobutton'
import RadioButtonGroup from 'primevue/radiobuttongroup'
import Select from 'primevue/select'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import ToggleSwitch from 'primevue/toggleswitch'

import ro from './primevue-ro.json'
import Aura from '@primevue/themes/aura'

export default (app) => {
  app.use(PrimeVue, {
    locale: ro,
    theme: {
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: false,
        cssLayer: false,
      },
    },
    pt: {
      inputtext: {
        root: {
          // class: 'input',
        },
      },
      multiselect: {},
    },
  })

  app.use(ConfirmationService)
  app.use(ToastService)

  app.component('Button', Button)
  app.component('Chart', Chart)
  app.component('Checkbox', Checkbox)
  app.component('CheckboxGroup', CheckboxGroup)
  app.component('Column', Column)
  app.component('ConfirmDialog', ConfirmDialog)
  app.component('DatePicker', DatePicker)
  app.component('DataTable', DataTable)
  app.component('Dialog', Dialog)
  app.component('InputGroup', InputGroup)
  app.component('InputGroupAddon', InputGroupAddon)
  app.component('InputMask', InputMask)
  app.component('InputNumber', InputNumber)
  app.component('InputText', InputText)
  app.component('Menu', Menu)
  app.component('MultiSelect', MultiSelect)
  app.component('ProgressSpinner', ProgressSpinner)
  app.component('RadioButton', RadioButton)
  app.component('RadioButtonGroup', RadioButtonGroup)
  app.component('Select', Select)
  app.component('Textarea', Textarea)
  app.component('Toast', Toast)
  app.component('ToggleSwitch', ToggleSwitch)

  app.component('Form', Form)
  app.component('FormField', FormField)
}
